module.exports = __webpack_public_path__ + "assets/img/JLD_Business Bldgs_RGB_lr.2b0e78a4.png";